// What a failed read of the product plane says to the user. The views show
// it where the existing entity details show their errors.

// The message of a read the graph service could not answer
export const GRAPH_UNAVAILABLE_MESSAGE =
  "The graph service is unavailable. Please try again later.";

const statusOf = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } } | null)?.response?.status;

/**
 * The message for a failed read of one entity.
 *
 * @param error - What the read threw
 * @param subject - What was read, capitalised, e.g. "Product"
 * @returns "<subject> not found" for a 404, the graph-unavailable message
 *   for a 503, else the error's own message
 */
export const planeErrorMessage = (error: unknown, subject: string): string => {
  const status = statusOf(error);
  if (status === 404) {
    return `${subject} not found`;
  }
  if (status === 503) {
    return GRAPH_UNAVAILABLE_MESSAGE;
  }
  return (
    (error as Error | null)?.message ||
    `Failed to load ${subject.toLowerCase()} details`
  );
};
